// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__MiWT4","disabled":"Radio_disabled__V7IiS","radio":"Radio_radio__zZyob","white":"Radio_white__19z8G","input":"Radio_input__m3Xes"};